// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"dede0f3a94e7822e","537":"e559989474e2bb45","972":"17acfd19df3c445c"}[chunkId] + ".js";
};